import AttachmentWellViewState from '../schema/AttachmentWellViewState';
import { AttachmentFullViewState } from 'owa-attachment-full-data';
import { ClientAttachmentId, isClientAttachmentIdEqual } from 'owa-client-ids';

export default function getAttachmentFullViewStateById(
    attachmentWell: AttachmentWellViewState,
    attachmentId: ClientAttachmentId
): AttachmentFullViewState {
    let results = attachmentWell.docViewAttachments.filter(
        (attachment: AttachmentFullViewState) => {
            return isClientAttachmentIdEqual(attachment.attachmentId, attachmentId);
        }
    );

    if (results.length === 0) {
        results = attachmentWell.imageViewAttachments.filter(
            (attachment: AttachmentFullViewState) => {
                return isClientAttachmentIdEqual(attachment.attachmentId, attachmentId);
            }
        );
    }

    return results.length === 0 ? null : results[0];
}
